<template>
  <div>
    <v-card tile flat class="px-4 pt-4" color="#F5F7FA">
      <v-card-text>
        <v-row>
          <v-col cols="auto">
            <pet-profile-avatar ref="avatar"></pet-profile-avatar>
            <div class="d-flex justify-center mt-4">
              <v-card
                outlined
                ripple
                width="38"
                class="pointer"
                @click="$refs.qrcodeDialog.showPetQrcode(petId)"
              >
                <v-icon large color="black">mdi-qrcode</v-icon>
              </v-card>
            </div>
          </v-col>
          <v-col v-col cols="10">
            <div class="d-flex flex-column">
              <div class="d-flex align-center">
                <span class="headline black--text" v-text="pet.name"></span>
                <v-chip label class="ml-5" color="white">
                  <span v-text="pet.breed"></span>
                </v-chip>
              </div>
              <div>
                <v-row>
                  <v-col
                    cols="auto"
                    v-for="profile in petProfile"
                    :key="profile.key"
                    class="d-flex flex-row align-center"
                  >
                    <span
                      v-text="profile.value"
                      class="title black--text"
                    ></span>
                    <div
                      class="ml-1"
                      v-text="profile.key"
                      style="width:60px"
                    ></div>
                  </v-col>
                </v-row>
              </div>
              <div>
                <pre
                  style="white-space: pre-wrap;word-wrap: break-word;"
                  v-text="pet.info"
                ></pre>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-tabs
        v-model="tab"
        slider-size="4"
        background-color="transparent"
        class="px-4"
      >
        <v-tab
          v-for="item in items"
          :key="item.key"
          :class="['title', $globalStyle.tabColor]"
          >{{ item.text }}</v-tab
        >
      </v-tabs>
    </v-card>
    <v-divider></v-divider>

    <v-tabs-items v-model="tab">
      <v-tab-item key="healthReport">
        <v-card flat>
          <div class="d-flex flex-row">
            <div>
              <v-navigation-drawer width="130" permanent>
                <!-- <VuePerfectScrollbar class="scroll-area"> -->
                <v-list dense class="pt-0" :height="previewHight">
                  <v-list-item-group color="cyan">
                    <v-list-item
                      v-for="report in reports"
                      :key="report._id"
                      :to="report._id"
                      replace
                    >
                      <v-list-item-content class="text-center">
                        <v-list-item-title
                          v-text="report.date.replace(/-/g, '/')"
                          class="body-2"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <!-- </VuePerfectScrollbar> -->
              </v-navigation-drawer>
            </div>
            <div class="flex-grow-1 pt-1 px-4 pb-4">
              <v-row justify="space-around">
                <v-col col="auto"></v-col>
                <v-col
                  col="auto"
                  class="text-center title"
                  v-text="reportTitle.replace(/-/g, '/')"
                ></v-col>
                <v-col col="auto" class="text-right">
                  <v-btn
                    class="mr-4"
                    :color="$classStyle.btnBg"
                    fab
                    depressed
                    small
                    @click="$refs.createReportDialog.showDialog()"
                  >
                    <v-icon :color="$classStyle.btnColor">mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    :color="$classStyle.btnBg"
                    :disabled="reports.length === 0"
                    fab
                    depressed
                    small
                    class="mr-4"
                    @click="
                      $router.push({
                        path: `${
                          $router.currentRoute.path
                        }/healthReport/${$my.getClinic()}/${reportTitle}`
                      })
                    "
                  >
                    <v-icon :color="$classStyle.btnColor">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    :color="$classStyle.btnBg"
                    fab
                    depressed
                    small
                    class="mr-4"
                    :disabled="reports.length === 0"
                    @click="
                      $refs.qrcodeDialog.showReportQrcode(
                        reportTitle.replace(/-/g, '/'),
                        reportId
                      )
                    "
                  >
                    <v-icon :color="$classStyle.btnColor">mdi-qrcode</v-icon>
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="$classStyle.btnBg"
                        fab
                        depressed
                        small
                        v-on="on"
                        :disabled="reports.length === 0"
                      >
                        <v-icon :color="$classStyle.btnColor"
                          >mdi-dots-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        :disabled="reports.length === 0"
                        @click="
                          $refs.deleteReportDialog.showForDeleteReport(
                            reportId,
                            reportTitle
                          )
                        "
                      >
                        <v-list-item-title>刪除</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <iframe width="100%" id="pdfView" :height="previewHight"></iframe>
            </div>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <dialog-edit-pet-profile
      ref="editDialog"
      @done="getPet"
    ></dialog-edit-pet-profile>
    <dialog-create-report
      ref="createReportDialog"
      :pet="pet"
      :petId="petId"
      @done="getReports"
    ></dialog-create-report>
    <dialog-delete-confirm
      ref="deleteReportDialog"
      @done="getReports(true)"
    ></dialog-delete-confirm>
    <dialog-delete-confirm
      ref="deletePetDialog"
      @done="$router.go(-1)"
    ></dialog-delete-confirm>
    <dialog-pet-qr-code ref="qrcodeDialog"></dialog-pet-qr-code>
    <socket-io
      :focusEvent="focusEvent"
      @onReceive="socketOnReceive"
    ></socket-io>
  </div>
</template>

<script>
// import VuePerfectScrollbar from "vue-perfect-scrollbar";

import DialogEditPetProfile from "./DialogEditPetProfile";
import DialogCreateReport from "./DialogCreateReport";
import DialogPetQrCode from "./DialogPetQrCode";
import PetProfileAvatar from "./PetProfileAvatar";

import DialogDeleteConfirm from "../common/DialogDeleteConfirm";
import SocketIo from "../common/SocketIo";

export default {
  props: ["petId", "reportId"],
  components: {
    // VuePerfectScrollbar,
    DialogEditPetProfile,
    DialogCreateReport,
    DialogDeleteConfirm,
    DialogPetQrCode,
    SocketIo,
    PetProfileAvatar
  },
  data: () => ({
    focusEvent: ["updateAvatar", "updateReport"],
    src: "",
    reports: [],
    selectedDate: "",
    pet: {},
    petProfile: [
      {
        key: "年齡",
        value: ""
      },
      {
        key: "出生",
        value: ""
      },
      {
        key: "畜主",
        value: ""
      },
      {
        key: "聯絡電話",
        value: ""
      }
    ],
    petPhoto: "",
    tab: "",
    items: [{ text: "健檢報告", key: "healthReport" }],
    reportTitle: ""
  }),
  methods: {
    async getPet() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/pets/1/${this.petId}`
      );
      //{"_id":"5ddb96e9cc848a5b3c67c29e","type":"cat","name":"momo","breed":"mixx","gender":"male","birth":"2012-04-13","phone":"0975339870","clinic":"ladyicats","info":""}
      this.petProfile[0].value = this.$common.parsePetAge(response.data.birth);
      this.petProfile[1].value = response.data.birth.replace(/-/g, "/");
      this.petProfile[2].value = response.data.userName;
      this.petProfile[3].value = response.data.userPhone;
      this.pet = response.data;

      this.$refs.avatar.setAvatar(this.pet);
    },
    async getReports(goFirst) {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/reports/${this.petId}/0`
      );
      this.reports = response.data;

      if (this.reports.length > 0) {
        if (this.reportId === "0" || goFirst) {
          this.$router.replace({ path: this.reports[0]._id });
        }
      } else if (goFirst) {
        this.$router.replace({ path: "0" });
      }
    },
    async showReport(reportId, forReload) {
      if (reportId !== "0") {
        let url = `${
          this.$config.apiUrl
        }/${this.$my.getClinic()}/pdfBinary/${reportId}/`;
        if (forReload) {
          url += "?t=" + new Date().getTime();
        }
        this.src = url;

        document
          .getElementById("pdfView")
          .contentWindow.location.replace(this.src);

        //show title
        let title = "";
        this.reports.forEach(function(report) {
          if (report._id === reportId) {
            title = report.date;
          }
        });
        this.reportTitle = title;
      } else {
        this.src = "/pdfWhitePage";
        document
          .getElementById("pdfView")
          .contentWindow.location.replace(this.src);

        this.reportTitle = "";
      }
    },
    async socketOnReceive(event, data) {
      // console.log(event + ":" + JSON.stringify(data));
      if (event === "updateAvatar" && data.petId === this.petId) {
        this.$refs.avatar.setAvatar(this.pet, true);
        if (this.reportId !== "0") {
          this.showReport(this.reportId, true);
        }
      } else if (event === "updateReport" && this.petId === data.petId) {
        let reportIdNow = this.$router.currentRoute.path.replace(/^.*[/]/, "");

        let reportExist = false;
        this.reports.forEach(report => {
          if (report._id === data.reportId) {
            reportExist = true;
          }
        });

        if (reportIdNow === data.reportId) {
          console.log("refresh report");
          this.showReport(data.reportId, true);
        } else if (reportExist) {
          console.log("redirect to report");
          this.$router.replace({ path: data.reportId });
        } else {
          console.log("refresh report list");
          this.getReports();
        }
      }
    }
  },
  computed: {
    previewHight() {
      console.log("window.innerHeight:" + window.innerHeight);
      console.log("height:" + this.$vuetify.breakpoint.height);
      return this.$vuetify.breakpoint.height - 64 - 48 - 56 - 16 - 16;
    }
  },
  watch: {
    reportId(val) {
      this.showReport(val);
    },
    "$store.state.petProfileEditDialog": function() {
      this.$refs.editDialog.edit(this.petId, this.pet);
    },
    "$store.state.petProfileDeleteDialog": function() {
      this.$refs.deletePetDialog.showForDeletePet([this.pet]);
    }
  },
  async mounted() {
    this.tab = this.items[0].key;
    this.getPet();
    await this.getReports();
    if (this.reportId !== "0") {
      this.showReport(this.reportId);
    }
  },
  created() {}
};
</script>
